/**
 * Keep an amount field to digits and a single decimal point, at most two
 * places. Filtering on the way in beats validating on the way out.
 */
export function sanitiseAmount(raw: string): string {
  const digitsAndDot = raw.replace(/[^\d.]/g, '');
  const [whole = '', ...rest] = digitsAndDot.split('.');
  if (rest.length === 0) return whole;
  return `${whole}.${rest.join('').slice(0, 2)}`;
}
